import axios from '@/core/axios';

import {
  KpiDeviceFilters,
  KpiDeviceListQuery,
  KpiDeviceListResponse,
  KpiFilterOptions,
  KpiProductionRealtimeResponse,
  KpiProductionResponse,
  KpiQualityResponse,
  KpiQuery,
  KpiSalesResponse,
  KpiStockResponse
} from './kpis.types';

/* Retire les filtres vides (tableaux vides / undefined) pour ne pas polluer la query string */
const compactParams = (params: object): Record<string, unknown> =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && !(Array.isArray(v) && v.length === 0))
  );

/* Module Analyses > KPI : un endpoint par onglet, mis en cache côté backend. Toutes les requêtes
   acceptent les filtres device (KpiDeviceFilters). */
export class KpisService {
  production(query: KpiQuery = {}): Promise<KpiProductionResponse> {
    return axios
      .get<KpiProductionResponse>('/kpis/production', { params: compactParams(query) })
      .then(resp => resp?.data);
  }

  /* Tableaux temps réel de l'onglet Production (indépendants de la période) */
  productionRealtime(filters: Partial<KpiDeviceFilters> = {}): Promise<KpiProductionRealtimeResponse> {
    return axios
      .get<KpiProductionRealtimeResponse>('/kpis/production-realtime', { params: compactParams(filters) })
      .then(resp => resp?.data);
  }

  filterOptions(): Promise<KpiFilterOptions> {
    return axios.get<KpiFilterOptions>('/kpis/filter-options').then(resp => resp?.data);
  }

  /* Devices derrière une ligne d'un tableau de répartition (paginé) */
  devices(query: KpiDeviceListQuery): Promise<KpiDeviceListResponse> {
    return axios.get<KpiDeviceListResponse>('/kpis/devices', { params: compactParams(query) }).then(resp => resp?.data);
  }

  quality(query: KpiQuery = {}): Promise<KpiQualityResponse> {
    return axios.get<KpiQualityResponse>('/kpis/quality', { params: compactParams(query) }).then(resp => resp?.data);
  }

  stock(query: KpiQuery = {}): Promise<KpiStockResponse> {
    return axios.get<KpiStockResponse>('/kpis/stock', { params: compactParams(query) }).then(resp => resp?.data);
  }

  sales(query: KpiQuery = {}): Promise<KpiSalesResponse> {
    return axios.get<KpiSalesResponse>('/kpis/sales', { params: compactParams(query) }).then(resp => resp?.data);
  }
}

export const kpisService = new KpisService();
